module.exports = __webpack_public_path__ + "img/dog2.b9d1b017.png";